import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { inject, Injectable, NgZone } from '@angular/core';
import { asyncScheduler, type SchedulerLike, type Subscription } from 'rxjs';

const from = { opacity: 0 };
const to = { opacity: 1 };

export const fadeIn = trigger('fadeIn', [
  state('void', style(from)),
  state('false', style(to)),
  state('true', style(from)),
  transition('* => *', animate('300ms ease-out')),
]);

@Injectable({ providedIn: 'root' })
export class LeaveZoneScheduler implements SchedulerLike {
  private _ngZone = inject(NgZone);

  public schedule(...args: any[]): Subscription {
    return this._ngZone.runOutsideAngular(() =>
      // eslint-disable-next-line prefer-spread
      asyncScheduler.schedule.apply(asyncScheduler, args),
    );
  }

  public now(): number {
    return Date.now();
  }
}

@Injectable({ providedIn: 'root' })
export class EnterZoneScheduler {
  private _ngZone = inject(NgZone);

  public schedule(...args: any[]): Subscription {
    return this._ngZone.run(() =>
      // eslint-disable-next-line prefer-spread
      asyncScheduler.schedule.apply(asyncScheduler, args),
    );
  }

  public now(): number {
    return Date.now();
  }
}
